function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD707",
  d: "M17.57 13.95L11.043 2.67c-.157-.27-.382-.495-.652-.651-.27-.156-.578-.238-.89-.238-.312 0-.619.082-.89.238-.27.156-.495.38-.652.65L1.43 13.952c-.156.27-.239.577-.24.89 0 .313.082.62.239.892.156.27.38.496.652.652.27.157.578.24.89.24h13.06c.313 0 .62-.083.89-.24.271-.156.496-.381.653-.652.156-.272.238-.579.238-.892 0-.313-.083-.62-.24-.89zM8.907 7.126c0-.158.062-.309.174-.42.111-.111.262-.174.42-.174.157 0 .308.063.42.174.11.111.173.262.173.42v3.562c0 .158-.062.309-.174.42-.11.111-.262.174-.42.174-.157 0-.308-.063-.42-.174-.11-.111-.173-.262-.173-.42V7.125zM9.5 14.25c-.176 0-.348-.052-.495-.15-.146-.098-.26-.237-.328-.4-.067-.163-.085-.342-.05-.514.034-.173.119-.332.243-.456.125-.125.283-.21.456-.244.173-.035.352-.017.515.05.163.068.302.182.4.329.097.146.15.318.15.494 0 .236-.094.463-.261.63-.167.167-.394.261-.63.261z"
});

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.c1ad002b.svg";
export { ForwardRef as ReactComponent };